import React from 'react';

import { useEnsureSelectedBlueprintLoaded } from 'js/src/components/sketch/hooks/useEnsureSelectedBlueprintLoaded';
import { loadAllFolders } from 'js/src/data/media';
import { loadSketchControlsFromCookie } from 'js/src/data/sketch-controls/sketch-controls-cookies';
import { loadTemplatesAndCategories } from 'js/src/data/templates';
import { useOnceBrowserIdleEffect } from 'js/src/hooks/useOnceBrowserIdleEffect';
import { useAppDispatch } from 'js/src/libs/RootState';

/**
 * Hook that load data necessary for Sketch UI
 */
export function useLoadSketchData() {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(loadSketchControlsFromCookie());
        dispatch(loadTemplatesAndCategories());
    }, [dispatch]);

    useOnceBrowserIdleEffect(() => {
        dispatch(loadAllFolders());
    }, [dispatch]);

    useEnsureSelectedBlueprintLoaded();
}
